import React, { useRef } from 'react'
import SendIcon from '@mui/icons-material/Send';
import { Box, Button, FormControlLabel, TextField, Typography, Checkbox, FormGroup, TextareaAutosize, Select, MenuItem, Paper } from '@mui/material'
import { useState, useEffect } from 'react';
import { Home, CameraAlt, PhotoCamera } from '@mui/icons-material';
import useAccessCode from '../hooks/useAccessCode';
import { CameraComponent } from '../components/CameraComponent';
import { CustomModal } from '../components/Modal';
import { IMotive } from '../models/codes';
import { useNavigate } from 'react-router-dom';
import { ShareCode } from '../components/ShareCode';
import { getTodayDate } from '../utils/date';
import { useAppSelector } from '../redux/hooks';

export const CrearAccesoFrecuente = () => {

    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)

    const [motivesList, setMotivesList] = useState<IMotive[]>([])

    const userData = useAppSelector((state) => state.auth.userData)

    const [dpiFile, setDpiFile] = useState<File | null>(null);
    const [personFile, setPersonFile] = useState<File | null>(null);
    const [showCamera, setShowCamera] = useState(false);
    const [showCameraForDpi, setShowCameraForDpi] = useState(false);
    const fileInputRefDpi = useRef<HTMLInputElement>(null);
    const fileInputRefPhoto = useRef<HTMLInputElement>(null);
    const [selectedDays, setSelectedDays] = useState({
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    });

    const [openQRModal, setOpenQRModal] = useState(false)
    const [modalMessage, setModalMessage] = useState('')

    const [accessCode, setAccessCode] = useState('')

    const { getMotives, crearAccesoFrecuente } = useAccessCode()

    useEffect(() => {
        (async () => {
            setLoading(true)
            const motives = await getMotives()
            if (motives) {
                setMotivesList(motives)
                setLoading(false)
            }
        })()
    }, [])

    const handleOpen = () => setOpenQRModal(true);
    const handleClose = () => {
        setOpenQRModal(false)
        setAccessCode('')
        navigate('/home')
    }

    const openCamera = (isDpi: boolean) => {
        setShowCamera(true);
        setShowCameraForDpi(isDpi);
    };

    const closeCamera = () => {
        setShowCamera(false);
    };

    const handleCameraCapture = (capturedFile: File) => {
        if (showCameraForDpi) {
            setDpiFile(capturedFile);
        } else {
            setPersonFile(capturedFile);
        }
        setShowCamera(false);
    };

    const handleFileSelect = (isDpi: boolean) => {
        if (isDpi) {
            fileInputRefDpi.current?.click();
        } else {
            fileInputRefPhoto.current?.click();
        }
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault()
        const { nombre, fechaInicio, fechaFin, nota, horaInicio, horaFin, correo, motivo } = e.target.elements

        // Create FormData for file uploads
        const formData = new FormData();
        formData.append('nombreVisita', nombre.value);
        formData.append('fechaInicio', fechaInicio.value);
        formData.append('fechaFin', fechaFin.value);
        formData.append('nota', nota.value);
        formData.append('horaInicio', horaInicio.value);
        formData.append('horaFin', horaFin.value);
        formData.append('luneas', String(selectedDays.monday));
        formData.append('martes', String(selectedDays.tuesday));
        formData.append('miercoles', String(selectedDays.wednesday));
        formData.append('jueves', String(selectedDays.thursday));
        formData.append('viernes', String(selectedDays.friday));
        formData.append('sabado', String(selectedDays.saturday));
        formData.append('domingo', String(selectedDays.sunday));
        formData.append('empresa', userData?.empresa.toString() || '');
        formData.append('usuario', userData?.usuario || '');
        formData.append('destino', '12');
        formData.append('origen', '3');
        formData.append('correo', correo.value);
        formData.append('Param1', `${userData?.agencia}|${userData?.casa}|1`);
        formData.append('ID_Casa', userData?.casa.toString() || '');
        formData.append('agencia', userData?.agencia.toString() || '');
        formData.append('motivo', motivo.value);
        formData.append('UUId', `acb3f5c0-5b9f-11eb-ae93-0242ac130002`,);

        if (dpiFile) {
            formData.append('file', dpiFile);
            formData.append('file_name', 'dpi_' + nombre.value.trim())
        }
        if (personFile) {
            formData.append('file2', personFile);
            formData.append('file_name2', 'foto_' + nombre.value.trim())
        }


        try {
            let code = await crearAccesoFrecuente(formData);
            if (code && code.success) {
                setAccessCode(code.codigo_Acceso)
                setModalMessage('Tu Codigo Diceros es *'+code.codigo_Acceso+ '* Muestralo en Garita para un acceso mas rapido !')
            } else {
                setModalMessage('Error al crear el código de acceso')
            }
        } catch (error) {
            setModalMessage('Error al crear el código de acceso')
        }
        handleOpen()
    }

    if (loading) {
        return (
            <Box textAlign="center" display="flex" alignItems="center" flexDirection='column'>
                <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                    Cargando...
                </Typography>
            </Box>
        )
    }

    return (
        <Box textAlign="center" display="flex" alignItems="center" flexDirection='column'>

            <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                Crear Acceso Frecuente

            </Typography>

            <Box component="form" display="flex" flexDirection="column" alignItems='center' width={0.8} maxWidth={500} onSubmit={handleSubmit} >

                <TextField
                    fullWidth
                    required
                    name='nombre'
                    label="Nombre"
                    variant="outlined"
                    sx={{ marginY: 2, input: { textTransform: 'uppercase' } }}
                    onInput={(e) => {
                        const input = e.target as HTMLInputElement;
                        input.value = input.value.replace(/[-'"\\;]/g, '').toUpperCase();
                    }}
                />

                <TextField fullWidth name='correo' label="Correo" required variant="outlined" sx={{ marginY: 2 }} />

                <TextField
                    required
                    fullWidth
                    name='fechaInicio'
                    label="Fecha Inicio"
                    defaultValue={getTodayDate().slice(0, 10)}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    sx={{ marginY: 2 }}
                />

                <TextField
                    required
                    fullWidth
                    name='fechaFin'
                    label="Fecha Fin"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    sx={{ marginY: 2 }}
                />
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                        required
                        fullWidth
                        name='horaInicio'
                        label="Hora Inicio (0-23)"
                        type="number"
                        defaultValue={8}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            min: 0,
                            max: 23,
                            step: 1
                        }}
                        sx={{ marginY: 2 }}
                        onChange={(e) => {
                            let value = parseInt(e.target.value);
                            if (value < 0) e.target.value = '0';
                            if (value > 23) e.target.value = '23';
                        }}
                    />

                    <TextField
                        required
                        fullWidth
                        name='horaFin'
                        label="Hora Fin (0-23)"
                        type="number"
                        defaultValue={17}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            min: 0,
                            max: 23,
                            step: 1
                        }}
                        sx={{ marginY: 2 }}
                        onChange={(e) => {
                            let value = parseInt(e.target.value);
                            if (value < 0) e.target.value = '0';
                            if (value > 23) e.target.value = '23';
                        }}
                    />
                </Box>

                <TextField
                    select
                    required
                    fullWidth
                    name='motivo'
                    label="Motivo"
                    defaultValue=""
                    variant="outlined"
                    sx={{ marginY: 2 }}
                >
                    {motivesList.map((motivo) => (
                        <MenuItem key={motivo.nombre} value={motivo.motivo}>
                            {motivo.nombre}
                        </MenuItem>
                    ))}
                </TextField>

                <Typography variant="subtitle1" sx={{ alignSelf: 'flex-start', marginY: 1 }}>
                    Días de la semana
                </Typography>

                <FormGroup sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginY: 1 }}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.monday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, monday: e.target.checked })}
                        />}
                        label="Lunes"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.tuesday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, tuesday: e.target.checked })}
                        />}
                        label="Martes"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.wednesday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, wednesday: e.target.checked })}
                        />}
                        label="Miércoles"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.thursday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, thursday: e.target.checked })}
                        />}
                        label="Jueves"
                    />
                </FormGroup>
                <FormGroup sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: 2, marginY: 1 }}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.friday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, friday: e.target.checked })}
                        />}
                        label="Viernes"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.saturday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, saturday: e.target.checked })}
                        />}
                        label="Sábado"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            checked={selectedDays.sunday}
                            onChange={(e) => setSelectedDays({ ...selectedDays, sunday: e.target.checked })}
                        />}
                        label="Domingo"
                    />
                </FormGroup>

                <TextareaAutosize
                    minRows={3}
                    placeholder="Nota"
                    name="nota"
                    required
                    style={{
                        width: '100%',
                        marginTop: '16px',
                        marginBottom: '16px',
                        padding: '8px',
                        fontFamily: 'inherit',
                        fontSize: 'inherit',
                        borderRadius: '4px',
                        borderColor: '#ccc',
                        textTransform: 'uppercase'
                    }}
                    maxLength={150}
                    onInput={(e) => {
                        const input = e.target as HTMLTextAreaElement;
                        input.value = input.value.replace(/[-'"\\;]/g, '').toUpperCase();
                    }}
                />

                <Typography variant="subtitle1" sx={{ alignSelf: 'flex-start', marginY: 1 }}>
                    Documentos
                </Typography>

                <Box sx={{ width: '100%', display: 'flex', gap: 2, marginY: 2 }}>
                    <Paper 
                        elevation={3} 
                        sx={{
                            flex: 1,
                            padding: 3,
                            border: '2px dashed #ccc',
                            borderColor: dpiFile ? 'success.main' : 'grey.300',
                            backgroundColor: dpiFile ? 'success.50' : 'grey.50'
                        }}
                    >
                        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                            {dpiFile ? (
                                <>
                                    <Typography variant="h6" color="success.main">
                                        ✓ DPI seleccionado
                                    </Typography>
                                    <Box sx={{ 
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 1,
                                        padding: 1,
                                        backgroundColor: '#f5f5f5',
                                        marginY: 1
                                    }}>
                                        <img
                                            src={URL.createObjectURL(dpiFile)}
                                            alt="DPI Preview"
                                            style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'contain' }}
                                        />
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Typography variant="h6">
                                        DPI
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Tome una foto o seleccione un archivo
                                    </Typography>
                                </>
                            )}
                            
                            <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
                                <Button
                                    variant="contained"
                                    startIcon={<CameraAlt />}
                                    onClick={() => openCamera(true)}
                                    sx={{ minWidth: 120 }}
                                >
                                    Cámara
                                </Button>

                                <Button
                                    variant="outlined"
                                    startIcon={<PhotoCamera />}
                                    onClick={() => handleFileSelect(true)}
                                    sx={{ minWidth: 120 }}
                                >
                                    Galería
                                </Button>
                            </Box>

                            <input
                                ref={fileInputRefDpi}
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) setDpiFile(file);
                                }}
                                style={{ display: 'none' }}
                            />
                        </Box>
                    </Paper>

                    <Paper 
                        elevation={3} 
                        sx={{
                            flex: 1,
                            padding: 3,
                            border: '2px dashed #ccc',
                            borderColor: personFile ? 'success.main' : 'grey.300',
                            backgroundColor: personFile ? 'success.50' : 'grey.50'
                        }}
                    >
                        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                            {personFile ? (
                                <>
                                    <Typography variant="h6" color="success.main">
                                        ✓ Foto seleccionada
                                    </Typography>
                                    <Box sx={{ 
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 1,
                                        padding: 1,
                                        backgroundColor: '#f5f5f5',
                                        marginY: 1
                                    }}>
                                        <img
                                            src={URL.createObjectURL(personFile)}
                                            alt="Foto Preview"
                                            style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'contain' }}
                                        />
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Typography variant="h6">
                                        Foto
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Tome una foto o seleccione un archivo
                                    </Typography>
                                </>
                            )}
                            
                            <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
                                <Button
                                    variant="contained"
                                    startIcon={<CameraAlt />}
                                    onClick={() => openCamera(false)}
                                    sx={{ minWidth: 120 }}
                                >
                                    Cámara
                                </Button>

                                <Button
                                    variant="outlined"
                                    startIcon={<PhotoCamera />}
                                    onClick={() => handleFileSelect(false)}
                                    sx={{ minWidth: 120 }}
                                >
                                    Galería
                                </Button>
                            </Box>

                            <input
                                ref={fileInputRefPhoto}
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) setPersonFile(file);
                                }}
                                style={{ display: 'none' }}
                            />
                        </Box>
                    </Paper>
                </Box>

                <Button type='submit' color='secondary' size='large' variant="contained" endIcon={<SendIcon />} sx={{ marginY: 2, width: '50%' }} > OK </Button>

            </Box>

            <CustomModal
                openState={openQRModal}
                onCloseHandler={handleClose}
            >

                <Typography variant="h6">
                    Codigo de Acceso
                </Typography>

                {accessCode !== '' && <ShareCode accessCode={accessCode} message={modalMessage} />}

                {accessCode === '' && <>

                    <Typography variant="h6" component="div" gutterBottom>
                        {modalMessage}
                    </Typography>

                </>}

                <Button color='secondary' variant="outlined" endIcon={<Home />} sx={{ marginY: 2, width: '50%' }} onClick={handleClose} >
                    Inicio
                </Button>

            </CustomModal>

            {/* Camera Component as Modal */}
            {showCamera && (
                <CameraComponent
                    isOpen={showCamera}
                    onClose={closeCamera}
                    onCapture={handleCameraCapture}
                />
            )}

        </Box>
    )
}
